var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"d-none d-lg-block ma-16 pa-16",domProps:{"innerHTML":_vm._s(_vm.$t('privacy'))}}),_c('div',{staticClass:"d-lg-none",domProps:{"innerHTML":_vm._s(_vm.$t('privacy'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }